import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DealsWizardModel ,BankModel,CreditCardYearModel} from '../../../_models/_index';
import { DealStepEnum,DealStatusEnum ,DealPaymentTypeEnum} from '../../../_enums/_index';
import { GeneralService} from '../../../services/general.service'
import { UserService } from '../../../services/user.service';
import { InfraService } from '../../../services/infra.service';
import { DealService } from '../../../services/deal.service';

@Component({
    selector: 'app-deal-payment',
    templateUrl: './deal-payment.component.html',
    styleUrls: ['./deal-payment.component.css']
})
export class DealPaymentComponent implements OnInit {
    year: string;
    month: string;
    monthList: string[];
    banks: BankModel[];
    tz1HasError: boolean;
    tz2HasError: boolean;
    yearsList: CreditCardYearModel[];


    @Input()
    dealsWizard: DealsWizardModel;

    @Input()
    dealStep: DealStepEnum;

    @Output()
    private nextStepEvent: EventEmitter<DealStepEnum>;

    constructor(private generalService: GeneralService,
        private dealService: DealService,
        private infraService: InfraService,
        private userService: UserService) {
        this.nextStepEvent = new EventEmitter<DealStepEnum>();
        this.monthList = this.generalService.getMonthList();

    }

    loadBanks()
    {
        this.infraService.getBanks().then(result => {
            this.banks = result;
        });
    }

    loadCreditCardYearsList() {
        this.dealService.getCreditCardYearList().then(result => {
            this.yearsList = result;
        });
    }

    ngOnInit() {
        if (this.dealsWizard  ) {
            if (!this.dealsWizard.paymentType)
                this.dealsWizard.paymentType = 1;
            if (this.dealsWizard.creditCardExpiryDate)
            {
                this.month = this.dealsWizard.creditCardExpiryDate.substring(0, 2);
                this.year = this.dealsWizard.creditCardExpiryDate.substring(2);
            }
        }

        this.loadBanks();
        this.loadCreditCardYearsList();
    }

    isCustomer() {
        return this.userService.isCustomer();
    }

    validate() {
        let validate: boolean = true;

        if (this.dealsWizard.paymentType == DealPaymentTypeEnum.CreditCard) {
            validate = !this.dealsWizard.creditCardIdentityNumber || this.validateTZ(this.dealsWizard.creditCardIdentityNumber);
            this.tz1HasError = !validate;
        }
        else {
            validate = !this.dealsWizard.bankIdentityNumber || this.validateTZ(this.dealsWizard.bankIdentityNumber);
            this.tz2HasError = !validate;
        }

        return validate;
    }

    nextStep() {
        if (this.validate()) {
            this.dealsWizard.creditCardExpiryDate = this.month + this.year;
            this.dealStep++;
            this.nextStepEvent.emit(this.dealStep);
        }
    }

    prevStep() {
        this.dealsWizard.creditCardExpiryDate = this.month + this.year;
        this.dealStep = this.dealStep - 1;
        this.nextStepEvent.emit(this.dealStep);
    }

    isReadOnly() {
        return this.dealsWizard.statusID > 3 ;
    }

    isRequired() {
        return this.userService.isCustomer() && (this.dealsWizard.statusID == DealStatusEnum.Opened || this.dealsWizard.statusID == DealStatusEnum.Sent) && this.dealsWizard.paymentType==1 ;
    }

    validateTZ(num) {
       return this.generalService.validateTZ(num);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-payment/deal-payment.component.ts